module.exports = __webpack_public_path__ + "img/north_korea.072625f.webp";